import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-hero">
          <h1>Contact Us</h1>
          <p className="hero-subtitle">
            We'd love to hear from you! Get in touch with any questions, feedback, or just to say hi.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <h2>Get in Touch</h2>
              <p>
                Have questions about our menu, want to provide feedback, or interested in partnerships? 
                We're here to help!
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email Us</h4>
                    <p>contact@bunny-boba.com</p>
                    <small>We'll respond within 24 hours</small>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">📱</div>
                  <div>
                    <h4>Call or WhatsApp</h4>
                    <p>+91 8920559306</p>
                    <small>Mon-Fri, 11 AM - 10 PM</small>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">📍</div>
                  <div>
                    <h4>Visit Our Location</h4>
                    <p>Town Central Mall<br />, LGB-08 Block B, Greater Noida West, UP</p>
                  </div>
                </div>

                <div className="contact-method">
                  <div className="contact-icon">📱</div>
                  <div>
                    <h4>Social Media</h4>
                    <div className="social-links">
                      <a href="https://www.instagram.com/bunnyboba.social/" className="social-link" target="_blank" rel="noopener noreferrer">Instagram</a>
                      {/* <a href="https://facebook.com/bunnyboba" className="social-link" target="_blank" rel="noopener noreferrer">Facebook</a>
                      <a href="https://twitter.com/bunnyboba" className="social-link" target="_blank" rel="noopener noreferrer">Twitter</a> */}
                    </div>
                    <small>Follow us for updates!</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send us a Message</h2>
              
              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">✅</div>
                  <h3>Thank you for your message!</h3>
                  <p>We've received your inquiry and will get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="name">Full Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Your full name"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="your.email@example.com"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="general">General Inquiry</option>
                      <option value="menu">Menu Questions</option>
                      <option value="feedback">Feedback</option>
                      <option value="partnership">Partnership</option>
                      <option value="catering">Catering & Events</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows="6"
                      placeholder="Tell us how we can help you..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary btn-full">
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        {/* <section className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>When will you open?</h4>
              <p>We're planning to open in June 2025 at Town Central Mall, Greater Noida West.</p>
            </div>
            <div className="faq-item">
              <h4>Do you offer delivery?</h4>
              <p>Yes! We'll offer delivery through our website and popular food delivery platforms.</p>
            </div>
            <div className="faq-item">
              <h4>Are your drinks customizable?</h4>
              <p>Absolutely! You can customize sweetness, ice levels, and choose from various toppings.</p>
            </div>
            <div className="faq-item">
              <h4>Do you have vegan options?</h4>
              <p>Yes, we offer plant-based milk alternatives and vegan-friendly toppings.</p>
            </div>
          </div>
        </section> */}
      </div>

      <style jsx>{`
        .contact-page {
          min-height: 100vh;
          background-color: #fff8f0;
          padding: 40px 0 80px;
        }
        
        .contact-hero {
          text-align: center;
          padding: 60px 20px;
          background: linear-gradient(135deg, #fcf0ff, #fff1f2);
          border-radius: 20px;
          margin-bottom: 60px;
        }
        
        .contact-hero h1 {
          font-size: 3rem;
          color: #C2185B;
          margin-bottom: 20px;
          font-weight: bold;
        }
        
        .hero-subtitle {
          font-size: 1.2rem;
          color: #666;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          margin-bottom: 80px;
        }
        
        .contact-info h2,
        .contact-form-section h2 {
          color: #C2185B;
          font-size: 2rem;
          margin-bottom: 20px;
        }
        
        .contact-info p {
          color: #666;
          line-height: 1.7;
          margin-bottom: 30px;
        }
        
        .contact-methods {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }
        
        .contact-method {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          padding: 20px;
          background-color: white;
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
        
        .contact-icon {
          font-size: 1.5rem;
          flex-shrink: 0;
        }
        
        .contact-method h4 {
          color: #C2185B;
          margin-bottom: 5px;
          font-size: 1.1rem;
        }
        
        .contact-method p {
          color: #333;
          margin-bottom: 5px;
          line-height: 1.4;
        }
        
        .contact-method small {
          color: #666;
          font-size: 0.85rem;
        }
        
        .social-links {
          display: flex;
          gap: 10px;
        }
        
        .social-link {
          color: #C2185B;
          text-decoration: none;
          font-weight: 500;
        }
        
        .social-link:hover {
          text-decoration: underline;
        }
        
        .contact-form-section {
          background-color: white;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }
        
        .success-message {
          text-align: center;
          padding: 40px 20px;
        }
        
        .success-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        
        .success-message h3 {
          color: #10b981;
          margin-bottom: 15px;
        }
        
        .success-message p {
          color: #666;
        }
        
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 5px;
          color: #333;
          font-weight: 500;
        }
        
        .form-group input,
        .form-group select,
        .form-group textarea {
          width: 100%;
          padding: 12px 15px;
          border: 2px solid #e5e5e5;
          border-radius: 8px;
          font-size: 1rem;
          outline: none;
          transition: border-color 0.3s ease;
          font-family: inherit;
        }
        
        .form-group input:focus,
        .form-group select:focus,
        .form-group textarea:focus {
          border-color: #C2185B;
        }
        
        .form-group textarea {
          resize: vertical;
          min-height: 120px;
        }
        
        .btn-full {
          width: 100%;
          padding: 15px;
          font-size: 1rem;
          margin-top: 10px;
        }
        
        .faq-section {
          background-color: white;
          padding: 50px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }
        
        .faq-section h2 {
          text-align: center;
          color: #C2185B;
          font-size: 2.5rem;
          margin-bottom: 40px;
        }
        
        .faq-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
        }
        
        .faq-item {
          padding: 25px;
          background-color: #fcf0ff;
          border-radius: 10px;
        }
        
        .faq-item h4 {
          color: #C2185B;
          margin-bottom: 10px;
          font-size: 1.1rem;
        }
        
        .faq-item p {
          color: #666;
          line-height: 1.6;
        }
        
        @media (max-width: 768px) {
          .contact-hero h1 {
            font-size: 2.2rem;
          }
          
          .contact-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          
          .form-row {
            grid-template-columns: 1fr;
          }
          
          .contact-form-section,
          .faq-section {
            padding: 30px 25px;
          }
          
          .faq-section h2 {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default ContactPage; 